import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { ConfermaService } from '@shared/conferma/conferma-dialog.component';

/** Una pagina che ha qualcosa da perdere lo dichiara con questo metodo. */
export interface PuoAvereModificheNonSalvate {
  haModificheNonSalvate(): boolean;
}

/**
 * Chiede conferma prima di lasciare una pagina con modifiche non salvate.
 *
 * Serve perche' l'editor ora e' una pagina: un click sul menu laterale o il
 * tasto indietro del browser portano via il lavoro. Nella finestra modale il
 * problema non c'era, perche' non si navigava.
 */
export const modificheNonSalvate: CanDeactivateFn<PuoAvereModificheNonSalvate> = async (componente) => {
  if (!componente?.haModificheNonSalvate()) return true;

  return inject(ConfermaService).chiedi({
    titolo: 'Lasciare la pagina?',
    testo: 'Ci sono modifiche non salvate: uscendo adesso vanno perse.',
    conferma: 'Esci senza salvare',
    annulla: 'Resta qui',
    distruttiva: true,
  });
};
